import * as React from 'react';
import { SVGProps } from 'react';

const IconBackwardSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m2.71 6 2.647-2.646-.707-.708L.796 6.5l3.854 3.854.707-.708L2.711 7H10V6H2.71z" />
  </svg>
);
export default IconBackwardSizeXs;
